import { AvailableGridTypes } from './../../types/category/categoryTypes';
import {
  AvailableBasePathTypes,
  AvailableCountryNameTypes,
} from './../../types/common';
export const QUICKSILVER_FEATURES_COOKIE = 'QUICKSILVER_FEATURES';

export const COUNTRY_CODE_COOKIE_KEY = 'country';

export const CRM_COOKIES_CONSENT_KEY = 'cdb';

export const TEALLIUM_COOKIE_KEY = 'utag_main';
export const TEALLIUM_USER_ID = 'v_id';

export const GAMING_ROLLOUT_COOKIE_NAME = 'vegas-migration';

export const VERTICALS_FOR_SIMPLIFIED_ROLLOUT_TRACKING = ['Poker'];

export const VERTICALS_WITH_ROLLOUT_ENABLED = ['poker', 'bingo'];

export const GAMING_SEGMENTS_COOKIE_NAME = 'vegas-segments';

export const PERSONALIZATION_COOKIE_NAME = 'x-force-personalization';

export const IDLE_POPUP_SHORT_PAUSE_COOKIE_KEY = 'idle-popup-sp'; // 1 hour
export const IDLE_POPUP_LONG_PAUSE_COOKIE_KEY = 'idle-popup-lp'; // 7 days

export const MAXIMUM_BANNER_SIZE = 1440;

export const BASE_PATH_TO_COUNTRY_NAME_MAP: {
  [key in AvailableBasePathTypes]: AvailableCountryNameTypes;
} = {
  'en-gb': 'United Kingdom',
  'en-ca': 'Canada',
  'en-ie': 'Ireland',
  'de-at': 'Austria',
  'ja-jp': 'Japan',
  'ru-ru': 'Russia',
};

export const CHUNK_SIZE_MAP: {
  [key in AvailableGridTypes]: { normal: number; big: number };
} = {
  'Jackpot Nine': {
    normal: 9,
    big: 9,
  },
  'Game Dual': {
    normal: 5,
    big: 6,
  },
  'Game Banner': {
    normal: 4,
    big: 7,
  },
  'Game List': {
    normal: 4,
    big: 8,
  },
  'Widget Banner': {
    normal: 3,
    big: 6,
  },
  'Jackpot Banner': {
    normal: 3,
    big: 6,
  },
  'Widget Hero': {
    normal: 5,
    big: 6,
  },
  'Jackpot Hero': {
    normal: 5,
    big: 6,
  },
  'Game Shuffle Hero': {
    normal: 5,
    big: 6,
  },
  'Single Block': {
    normal: 3,
    big: 6,
  },
  'Extended Single Block': {
    normal: 3,
    big: 6,
  },
  Grid: {
    normal: 3,
    big: 6,
  },
  'Dynamic Grid': {
    normal: 12,
    big: 12,
  },
  Collection: {
    normal: 12,
    big: 12,
  },
  Banner: {
    normal: 1,
    big: 1,
  },
  'Tall Single Block': {
    normal: 1,
    big: 1,
  },
  'Top Games': {
    normal: 1,
    big: 1,
  },
  'Vertical Horizontal': {
    normal: 1,
    big: 1,
  },
  'Dual Vertical Horizontal': {
    normal: 1,
    big: 1,
  },
  'Horizontal Vertical': {
    normal: 1,
    big: 1,
  },
  'Dual Horizontal Vertical': {
    normal: 1,
    big: 1,
  },
};

export const HOMEPAGE_BASE_PATH = '/';

export const CONTEXT_ATTRIBUTES = [
  'agent',
  'segments',
  'source',
  'game_sub_category',
  'game_top_category',
];

export const WEB_ATTRIBUTES = [
  'agent',
  'segments',
  'game_sub_category',
  'game_top_category',
];

export const MOBILE_DEVICES = ['mobile', 'tablet'];

export const TRANSPARENT_FAVICON_URL =
  'https://eu-images.contentstack.com/v3/assets/bltb3d7d79707153158/bltc76fc98fccadad9c/vegas-favicon-transparent.png';

export const MAX_RECENTLY_PLAYED_GAMES = 6;
export const MIN_RECENTLY_PLAYED_GAMES = 3;
